import { FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';

import { FormUtils } from 'tiime-expert-utils';

import { SelectElementForm } from '@forms/select-element-form/select-element-form';
import { SelectableElement } from '@interfaces/selectable-element';

export class SelectElementsFormArray<T extends SelectableElement = any> extends FormArray<SelectElementForm<T>> {
  get errorMessage(): string {
    return this.errors && !this.errors.atLeastOneSelectedElement ? this._errorMessage : null;
  }

  get allSelected(): boolean {
    return !this.controls.filter(control => !control.disabled).some(control => !control.selected?.value);
  }

  constructor(private _errorMessage: string = 'Sélection invalide - Vous devez sélectionner au moins un élément') {
    super([]);
  }

  private static atLeastOneSelectedElement(): ValidatorFn {
    return (formArray: SelectElementsFormArray): ValidationErrors => {
      if (formArray.controls.some((form: SelectElementForm) => form.selected.value)) {
        return null;
      }

      return {
        atLeastOneSelectedElement: false
      };
    };
  }

  override addValidators(): void {
    this.setValidators([SelectElementsFormArray.atLeastOneSelectedElement()]);
    this.updateValueAndValidity();
  }

  override removeValidators(): void {
    this.clearValidators();
    this.updateValueAndValidity();
  }

  toggleAllSelection(needToSelectAll: boolean, shouldNotEmit: boolean = false): void {
    if (!needToSelectAll) {
      this.unSelectAll(shouldNotEmit);
    } else {
      this.selectAll(shouldNotEmit);
    }
  }

  selectAll(shouldNotEmit: boolean = false): void {
    this.controls.forEach(control => {
      if (control.disabled) {
        return;
      }
      control.patchValue({ selected: true }, shouldNotEmit ? FormUtils.shouldNotEmitEvent : {});
    });
  }

  unSelectAll(shouldNotEmit: boolean = false): void {
    this.controls.forEach(control => {
      if (control.disabled) {
        return;
      }
      control.patchValue({ selected: false }, shouldNotEmit ? FormUtils.shouldNotEmitEvent : {});
    });
  }
}
